/**
 * @module:  helper处理模块
 * @author: Liang Huang
 * @date: 2019-09-30 16:39:12
 */

/**
 * 检测对象是否无属性
 * @param obj 对象
 */
export function isEmpty(obj: Object) {
  if (Object.prototype.toString.call(obj) !== '[object Object]') return null;
  return Object.values(obj).length === 0;
}

/**
 * 对比值的差异并返回promise
 * @param val1
 * @param val2
 * @returns {Promise}
 */
export function valueChanged<T>(val1: T, val2: T): Promise<any> {
  const p = new Promise((resolve, reject) => {
    if (val1 === val2) {
      reject(false);
    } else {
      resolve(true);
    }
  });
  return p;
}

/**
 * 页面回退
 */
export function back(isClosePage?: boolean) {
  // 如果是非hybrid环境，执行浏览器goback
  if (window.YwkHybrid.os.ywk) {
    window['YwkHybrid'].page.close({
      popPageNumber: isClosePage ? 0 : 1
    });
  } else {
    window.history.back();
  }
}

/**
 * 通知上一个页面刷新
 * @description 需要配合registerHandler page.nextPageClose 使用
 */
export function refresh() {
  if (window.YwkHybrid.os.ywk) {
    window['YwkHybrid'].page.notice();
  } else {
    window.location.reload();
  }
}
/**
 * 跳转页面
 * @description
 * 在app内新开webview加载；
 * 在wap端新开tab加载
 * @param {string} url
 * @param {*} history
 */
export function openPage(url: string, history: any) {
  if (process.env.NODE_ENV === 'development') {
    history.push(url);
  } else {
    const inApp = window.YwkHybrid.os.ywk ? true : false;
    const _url = `${location.origin}${url}`;
    if (inApp) {
      window.YwkHybrid.page.open({
        pageUrl: _url
      });
    } else {
      window.open(_url);
    }
  }
}
/**
 * check 字符串是否符合email
 * @param email
 */
export function validateEmail(email: string) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

/**
 * 处理未登录 唤起登录注册
 * @description mobile跳转到登录注册，app内唤起登录注册弹窗
 */
export function toLogin() {
  if (window.YwkHybrid.os.ywk) {
    window.YwkHybrid.runtime.showLoginDialog();
  } else {
    let url = encodeURIComponent(window.location.href);
    window.location.href = `/mresident/login?fromUrl=${url}`;
  }
}
